<template>
  <div class="main">

      <div class="tutorial-content-wrapper">
        <h3>What do you need to do in your SMS? <TextToSpeechSimple :inputText="textOneSpeech"></TextToSpeechSimple></h3>
        <h6 v-if="currentIndex == 0">Click on the "Show items" button below to see what goes into a safety management system.</h6>
        <ul>
          <transition-group name="fade">
            <li v-for="item in shownItems" :key="item.id">{{item.title}}</li>
          </transition-group>
        </ul>

        <hr>

        <button v-if="!hasInteracted" class="button is-link" @click="nextItem">{{currentIndex == 0 ? 'Show items' : 'Next item'}}</button>

      </div>

      <img class="smiley" v-if="hasInteracted" src="../assets/popeye.jpg" alt="Offshore SMS">
      <h4 v-if="hasInteracted">Nice work. Click on Next below.</h4>

      <div class="bottom-spacer"></div>
      <div class="bottom-spacer"></div>


  </div>
</template>


<script>

import { db } from '../main.js';
import TextToSpeechSimple from '../components/TextToSpeechSimple.vue';

export default {

  components: {
      TextToSpeechSimple,
  },

  props: [
      'interactionNeeded',
  ],

  mounted() {
    this.loadHelperItems();
  },

  computed: {
    shownItems() {
      return this.helperItems.filter(item => item.show == true);
    }
  },

  data() {
    return {
      hasInteracted: false,
      helperItems: [],
      currentIndex: 0,
      textOneSpeech: 'What do you need to do in your SMS? Keep clicking the blue button to see more items.',
    }
  },

  watch: {
    currentIndex() {
      if (this.currentIndex == this.helperItems.length) {
        this.sendData();
      }
    }
  },

  methods: {

    loadHelperItems() {
      var self = this;
      db.collection("smsImportantParts").orderBy("key","asc").onSnapshot(function(querySnapshot) {
        self.helperItems = [];
        querySnapshot.forEach(function(doc) {
          self.helperItems.push({
            id: doc.id,
            title: doc.data().title,
            key: doc.data().key,
            //show: doc.data().key == 0 ? true : false,
            show: false,
            // details: doc.data().details
          });
        });
      });
    },

    nextItem: function() {
      if (this.currentIndex < this.helperItems.length) {
        this.helperItems[this.currentIndex].show = true;
      }
      this.currentIndex++;
    },

    goBack: function() {
      console.log('Router',this.$router);
      this.$router.go(-1);
    },

    sendData: function() {
      let self = this;
      self.hasInteracted = true;
      let result = {
        hasInteracted: self.hasInteracted,
      }
      this.$emit('sendData', result)
    },
    
  }
}
</script>



<style lang="scss" scoped>

  button {
    margin-top: 1rem;
  }
  ul {
    margin: 2rem auto 1rem;
    max-width: 500px;
    li {
      line-height: 1.5rem;
      margin-bottom: 1.7rem;
      font-size: 1.2rem;
      text-indent: -29px;
      margin-left: 30px;
      &:before {
        content: url('../assets/tick.jpg');
        margin-right: 10px;
      }
    }
  }

</style>